import api from '../../services/api';

export interface TrendResponse {
  name: string;
  childTrends: Array<TrendResponse>;
  items: Array<ItemResponse>;
}

export interface ItemResponse {
  id: string;
  name: string;
  typeId: number;
  address: number;
}

export const fetchDataHistoryTrendLibrary = async (assetId: string | undefined, groupName: string | undefined) => {
  try {
    return await api
      .get('DataHistory?assetId=' + (assetId ?? '') + '&groupName=' + (groupName ?? ''), {
        headers: {
          'content-type': 'application/json',
        },
      })
      .then(function (response: any) {
        if (response) {
          return response.data;
        }
      });
  } catch (error) {
    console.error('Error fetching initial state:', error);
    throw error;
  }
};

export const fetchDataHistoryTrendItems = async (
  assetId = '',
  chart1TrendTypes = '',
  chart1TrendNames = '',
  chart1TrendAddresses = '',
  chart2TrendTypes = '',
  chart2TrendNames = '',
  chart2TrendAddresses = '',
  chart3TrendTypes = '',
  chart3TrendNames = '',
  chart3TrendAddresses = '',
  chart4TrendTypes = '',
  chart4TrendNames = '',
  chart4TrendAddresses = '',
  startDate = '',
  endDate = '',
  isOverlay?: number,
  groupName = '',
) => {
  try {
    const params = {
      assetId,
      chart1TrendTypes,
      chart1TrendNames,
      chart1TrendAddresses,
      chart2TrendTypes,
      chart2TrendNames,
      chart2TrendAddresses,
      chart3TrendTypes,
      chart3TrendNames,
      chart3TrendAddresses,
      chart4TrendTypes,
      chart4TrendNames,
      chart4TrendAddresses,
      startDate,
      endDate,
      isOverlay,
      groupName,
    };
    return await api
      .get('DataHistory/GetTrendDataAsync', {
        params,
        headers: {
          'content-type': 'application/json',
        },
      })
      .then(function (response: any) {
        if (!response || !response.data) {
          {
            return [];
          }
        } else {
          return response.data;
        }
      });
  } catch (error) {
    console.error('Error fetching initial state:', error);
    throw error;
  }
};

export const fetchGetDefaultTrendsData = async (
  assetId: string | undefined,
  viewId: string,
  startDate = '',
  endDate = '',
  isOverlay?: number,
) => {
  try {
    const params = {
      assetId,
      viewId,
      startDate,
      endDate,
      isOverlay,
    };
    return await api
      .get('DataHistory/GetDefaultTrendsData', {
        params,
        headers: {
          'content-type': 'application/json',
        },
      })
      .then(function (response: any) {
        if (!response || !response.data) {
          {
            return [];
          }
        } else {
          return response.data;
        }
      });
  } catch (error) {
    console.error('Error fetching initial state:', error);
    throw error;
  }
};
